import {BaseModel} from "./base-model";
import {BaseApiModel} from "./base-api-model";

export class BaseDomainModel extends BaseModel {
  apiModel: BaseApiModel;
  sortIndex: Number;
  id: Number;

  constructor(apiModel: BaseApiModel) {
    super();

    this.sortIndex = -1;
    this.apiModel = apiModel;
    this.id = apiModel?.id;
  }

  equals(model: BaseDomainModel) {
    const isSameId = this.id === model.id;

    return isSameId;
  }

  update(model: BaseDomainModel) {
    if (model) {
      this.apiModel = model.apiModel;
    }
  }
}
